// What this module needs from the app, typed structurally: nothing here imports the app, so the
// module can move to a package. `src/app/register-waf.tsx` builds it from real values and hands it
// to `createWafModule(host)` (module.ts). The HTTP client is not a member: it comes from the shared
// registry, `getHttpClient` of `@vnetwork/margarita-core/http`.

import type { HostBase } from '@vnetwork/margarita-shell/host-base';

export type WafHost = Pick<HostBase, 'trackFeatureAction' | 'categoryBackTarget'>;

let current: WafHost | null = null;

/** Called once by `createWafModule`, before any route renders. */
export function registerWafHost(host: WafHost): void {
  current = host;
}

/** The registered host. Throws when the module is used without `createWafModule(host)`. */
export function wafHost(): WafHost {
  if (!current) throw new Error('Waf: createWafModule(host) was not called before the module rendered');
  return current;
}

/** `host.trackFeatureAction`, resolved at call time so call sites read like the shared one. */
export const trackFeatureAction: WafHost['trackFeatureAction'] = (service, feature, verb, params) =>
  wafHost().trackFeatureAction(service, feature, verb, params);

/** `host.categoryBackTarget`, resolved at call time. */
export const categoryBackTarget: WafHost['categoryBackTarget'] = (categoryKey) => wafHost().categoryBackTarget(categoryKey);
